import * as M from 'shared/types/models';

export function isCabinetCell(cell: M.MatchingCabinets.Cell): cell is M.MatchingCabinets.CabinetCell {
  return cell.kind === 'cabinet';
}
